import React from 'react'
// import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import SignUp from './pages/signup/SignUp'
import Login from './pages/login/Login';
import Otp_Verification from './pages/otp_verification/Otp_Verification';
import Profile from './pages/profile/Profile';
import Edit_Profile from './pages/edit_profile/Edit_Profile';
import CreatePost_EditPost from './pages/Createpost_Editpost/CreatePost_EditPost';
import Mobile_Browser from './pages/Mobile_Browser/Mobile_Browser';
import Createpost_Repeatuser from './pages/Createpost_Repeatuser/Createpost_Repeatuser';
import My_Deals from './pages/My_Deals/My_Deals';
// import Mobile_Browser_Market from './pages/MobileBrower_Market/Mobile_Browser_Market';
// import Createpost_Newuser from './pages/Createpost_Newuser/Createpost_Newuser';
import Mobile_Browser_Market1 from './pages/Mobile_Browser_Market1/Mobile_Browser_Market1';
import MyDeals_AllBids from './pages/MyDeals_AllBids/MyDeals_AllBids';
import TnC from './pages/Terms_And_Condition/Terms_And_Condition';
import Privacy from './pages/Privacy_Policy/Privacy_Policy';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Mobile_Browser1 from './pages/MobileBrowser1/MobileBrowser1';
import EditPost from './pages/Editpost/EditPost';
import Mobile_Browser_Market2 from './pages/Mobile_Browser_Market2/Mobile_Browser_Market2';
import { ThemeProvider, useTheme } from '@material-ui/core/styles';
import Folder from './pages/Folder/Folder';
import ReactGA from 'react-ga';
import browsee from '@browsee/web-sdk';
import Sales_Login from './pages/Sales_Login/Sales_Login';
import Sales_Dashboard from './pages/Sales_Dashboard/Sales_Dashboard';
import My_Bids from './pages/My_Bids/My_Bids';

const trackingId = "G-8DPY4LRPG1";

browsee.init({ apiKey: '85f6c408148acf81e28d14445316f7c305ad25646fcce660' });

ReactGA.initialize(trackingId);

ReactGA.set({
  phoneNo: localStorage.getItem("Phone Number"),

  
})


function App() {
  const theme = useTheme();
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div>
          <Switch>
            <Route exact path="/">
              {isLoggedIn ? <Mobile_Browser /> : <Login /> }
            </Route>
            <Route exact path="/marketView">
              <Mobile_Browser />
            </Route>
            <Route path="/otpVerification">
              <Otp_Verification />
            </Route>
            <Route path="/signup">
              <SignUp />
            </Route>
            <Route path="/profile">
              <Profile />
            </Route>
            <Route path="/editprofile">
              <Edit_Profile />
            </Route>
            <Route path="/editPost">
              <EditPost />
            </Route>
            <Route path="/createEditpost">
              <CreatePost_EditPost />
            </Route>
            <Route path="/repeatUser">
              <Createpost_Repeatuser />
            </Route>
            <Route path="/mydeals">
              <My_Deals />
            </Route>
            <Route path="/mybids">
              <My_Bids />
            </Route>
            <Route exact path="/marketView/:dealId">
              <Mobile_Browser />
            </Route>
            <Route exact path="/allbids">
              <MyDeals_AllBids />
            </Route>
            <Route path="/folder">
              <Folder />
            </Route>
            <Route path="/t&c">
              <TnC />
            </Route>
            <Route path="/privacy-policy">
              <Privacy />
            </Route>
            <Route path="/sales">
              <Sales_Login/>
            </Route>
            <Route path="/sales-dashboard">
              <Sales_Dashboard />
            </Route>
            <Route path="*">
              <Mobile_Browser />
            </Route>

            {/* <Route path="/whatsapp">
              <Whatsapp />
            </Route> */}

            {/* <Route path="/marketView1">
            <Mobile_Browser />
          </Route> */}
            {/* </Route> */}
            {/* <Route path="/AllBids">
            <MyDeals_AllBids />
          </Route> */}
            {/* <Route exact path="/marketView">
            <Mobile_Browser />
          </Route> */}
            {/* <Route path="/marketView1">
            <Mobile_Browser_Market2 />
          </Route>
          <Route path="/folder">
              <Folder />
            </Route>
            <Route path="/marketView2">
              <Mobile_Browser_Market1 />
            </Route> */}

          </Switch>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
